module.exports = __webpack_public_path__ + "static/media/thumbs-down-fill.e89a012e.svg";